import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useLocalizedPath } from "@/hooks/useLocalizedNavigate";

interface Props {
  children: ReactNode;
}

/**
 * Wraps a page that requires authentication.
 *
 * - While auth is loading: renders a centred spinner so the page layout
 *   is not a blank flash (previously pages returned null).
 * - When loading resolves with no user: redirects to /:lang/connexion.
 * - When authenticated: renders children.
 */
export function ProtectedRoute({ children }: Props) {
  const { user, loading } = useAuth();
  const lp = useLocalizedPath();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={lp("/connexion")} replace />;
  }

  return <>{children}</>;
}
